import appStoreIcon from '../../../assets/img/app-store.svg';
import { toClassName } from '../../../utils/toClassName';
import styles from './AppStoreIcon.module.css';

export const AppStoreIcon = ({ customClass, onClick }) => {
  const className = toClassName(styles.container, customClass);
  return (
    <a
      onClick={onClick}
      className={className}
      href="https://apps.apple.com/fi/app/arkkeo/id1441284926"
      target="_blank"
      rel="noopener">
      <img src={appStoreIcon} alt="app_store" />
    </a>
  );
};
